import { render, staticRenderFns } from "./NovelGroupingDialog.vue?vue&type=template&id=19b8ee98&scoped=true"
import script from "./NovelGroupingDialog.vue?vue&type=script&lang=ts"
export * from "./NovelGroupingDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelGroupingDialog.vue?vue&type=style&index=0&id=19b8ee98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8ee98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b8ee98')) {
      api.createRecord('19b8ee98', component.options)
    } else {
      api.reload('19b8ee98', component.options)
    }
    module.hot.accept("./NovelGroupingDialog.vue?vue&type=template&id=19b8ee98&scoped=true", function () {
      api.rerender('19b8ee98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelGroupingDialog.vue"
export default component.exports